<template>
	<div class="link-input" :class="classes" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave" :style="styles">
		<div class="link-input-prepend" v-if="!!$slots.prepend">
			<slot name="prepend"></slot>
		</div>
		<span class="link-input-prefix-icon" v-if="!!prefixIcon" @click.stop="e=>$emit('click-prefix-icon',e)">
            <link-icon :icon="prefixIcon"/>
        </span>
		<div class="link-input-wrapper" @click="handleClickInput">
			<input
				ref="input"
				:value="currentValue"
				@input="lv_input"
				:placeholder="!!lv_disabled?'':placeholder"
				:disabled="lv_disabled"
				:readonly="lv_readonly || inputReadonly"
				@focus="e=>{p_isFocus = true;$emit('focus', e)}"
				@blur="e=>{p_isFocus = false;$emit('blur', e)}"
				:type="inputType"
				@keyup.enter="lv_keyenter"
				@keyup.back="e=>$emit('back', e)"
				@keydown="e=>$emit('keydown',e)"
				@keydown.up="lv_keyup"
				@keydown.down="lv_keydown"
				@keydown.left="lv_keyleft"
				@keydown.right="lv_keyright"
			/>
			<div class="link-input-clear-icon" @click.stop="handleClickClearIcon" v-if="!lv_disabled && !lv_readonly &&!hideClearIcon && !!hoverDeleteIcon&&hover&&!!currentValue">
				<link-icon icon="link-icon-close"/>
			</div>
		</div>
		<div class="link-input-suffix-icon" v-if="!!suffixIcon" @click.stop="handleClickSuffixIcon">
			<link-icon :icon="suffixIcon"/>
		</div>
		<div class="link-input-append" v-if="!!$slots.append">
			<slot name="append"></slot>
		</div>
		<div class="link-input-tooltip" v-show="!!validateMsg && validateMsg!==$t('LinkInput.requireText')">
			<span>{{ validateMsg }}</span>
		</div>
	</div>
</template>

<script>

import LinkIcon from '../icon/link-icon';
import {EditMixin} from '../mixins';

export default {
	name: 'link-input',
	mixins: [EditMixin],
	inject: {
		formItem: {default: null}
	},
	components: {
		LinkIcon,
	},
	props: {
		value: {default: null},                                                     //input双向绑定值
		type: {type: String, default: 'line',},                                     //样式类型fill、line、none
		color: {type: String, default: 'info',},                                    //颜色
		size: {type: String, default: 'default',},                                  //大小
		shape: {type: String, default: 'none',},                                    //形状
		dashed: {type: Boolean,},                                                   //虚线框
		long: {type: Boolean,},                                                     //占满父元素宽度
		prefixIcon: {type: String},                                                 //前置图标
		suffixIcon: {type: String, default: null},                                  //后置图标
		placeholder: {
			type: String, default() {
				return LinkVue.$t('LinkInput.placeholder')
			}
		},                     //占位符
		replacement: {type: String, default: ''},                                   // 设置替换文本或生成替换文本的函数。
		regexp: {type: RegExp},                                                     //替换正则表达式
		width: {type: Number | String, default: 200},                               //款速
		inputType: {type: String, default: 'text'},                                 //输入框原生类型，比如password、file等
		hoverDeleteIcon: {type: Boolean, default: true},                            //鼠标悬浮是的删除按钮
		clearOnClickDeleteIcon: {type: Boolean, default: true},                     //是否在点击删除图标的时候，请求内容
		focusOnHover: {type: Boolean},                                              //是否在鼠标悬浮的时候自动获取焦点
		hideClearIcon: {type: Boolean},                                             //是否隐藏清除按钮
		keyboard: {type: Boolean,},                                                 //是否监听键盘事件
		align: {type: String},                                                      //文本对齐方式

		required: {type: Boolean,},                                                 //是否必输
		rules: {type: Array | String},                                              //校验规则
		validateOnInit: {type: Boolean,},                                           //是否在组件初始化的时候就开始校验

		inputReadonly: {type: Boolean},                                             //输入框是否只读
		recommend: {type: Array},                                                   //推荐下拉选项
		recommendLov: {type: String},                                               //推荐值列表类型
		recommendFilter: {type: Function},                                          //推荐输入自定义筛选函数
	},
	watch: {
		value(val) {
			if (this.currentValue !== val) {
				this.currentValue = val;
			}
			this.handleValidate();
		},
		currentValue(val) {
			this.lv_resetRecommendData()
		},
		required(val) {
			this.handleValidate();
			!!this.formItem && (this.formItem.p_required = val)
		},
		recommend(val) {
			this.lv_recommendData = val
			this.lv_resetRecommendData()
		},
		recommendLov: {
			immediate: true,
			async handler(val) {
				if (!!this.recommend) {
					return
				} else if (!val) {
					this.lv_recommendData = null
					this.lv_resetRecommendData()
				} else {
					this.lv_recommendData = (await this.$lov.getLovByType(val)).map(item => item.name)
					this.lv_resetRecommendData()
				}
			},
		}
	},
	data() {
		return {
			currentValue: this.value,

			timer: null,
			hover: false,
			validateTimer: null,
			isValidate: true,
			validateMsg: null,
			p_isFocus: false,

			recommendOption: null,
			lv_recommendData: this.recommend,
			lv_showAllRecommendData: true,
			lv_recommendService: null
		};
	},
	computed: {
		classes() {
			return [
				`link-input-${!!this.dashed ? 'line' : this.type}`,
				`link-input-color-${this.color}`,
				`link-input-shape-${this.shape}`,
				`link-input-size-${this.size}`,
				{
					'link-input-long': !!this.long,
					'link-input-invalid': !this.isValidate,
					'link-input-disabled': !!this.lv_disabled,
					'link-input-readonly': !!this.lv_readonly,
					'link-input-dashed': !!this.dashed,
					'link-input-focus': this.p_isFocus,
					'link-input-has-suffix-icon': !!this.suffixIcon,
					[`link-input-align-${this.align}`]: !!this.align,
				},
			];
		},
		styles() {
			const styles = {}
			!!this.width && (styles.width = this.$lv.$utils.typeOf(this.width) === 'string' ? this.width : `${this.width}px`)
			return styles
		},
		currentRules() {
			let ret = []
			!!this.required && ret.push('required')
			!!this.rules && (ret = ret.concat(this.rules))
			return ret.length === 0 ? null : ret
		},
		recommendData() {
			if (!this.lv_recommendData) return null
			if (this.currentValue == null || this.currentValue === '' || !!this.lv_showAllRecommendData) return this.lv_recommendData
			return this.lv_recommendData.filter(item => {
				if (!!this.recommendFilter) return this.recommendFilter(item, this.currentValue)
				return item.indexOf(this.currentValue) > -1
			})
		},
	},
	mounted() {
		if (!!this.currentRules && !!this.validateOnInit) this.validate()
		if (!!this.formItem) (this.formItem.p_required = this.required)

		this.recommendOption = {
			autoFocus: false,
			onClose: () => this.lv_recommendService = null,
			onOpen: () => this.lv_resetRecommendData(),
			onConfirm: (ret) => {
				this.currentValue = ret
				this.$emit('input', this.currentValue)
				this.$emit('change', this.currentValue)
				this.$emit('select', ret)
			},
			reference: this.$el,
			slot: this.$scopedSlots.recommend,
			data: null,
		}
	},
	methods: {
		validate() {
			if (!this.currentRules) {
				this.isValidate = true
				this.validateMsg = null
				return true;
			}
			const result = this.$rule.validate(this.currentValue, this.required, this.rules)
			if (!!result) {
				this.isValidate = false
				this.validateMsg = result.msg
				return false
			} else {
				this.isValidate = true
				this.validateMsg = null
				return true
			}
		},
		cancelValidate() {
			this.isValidate = true
			this.validateMsg = null
		},
		async lv_input(e) {
			if (this.currentValue == e.target.value) return

			this.currentValue = e.target.value
			!!this.regexp && (this._replaceByRegexp());
			this.handleValidate();
			this.$emit('input', this.currentValue)
			this.$emit('change', this.currentValue)

			if (!!this.recommendData) {
				if (!this.lv_recommendService) {
					this.lv_openRecommendService()
				} else {
					this.lv_showAllRecommendData = false
					this.lv_resetRecommendData()
				}
			}
		},
		_replaceByRegexp() {
			if (this.currentValue == null || this.currentValue === '') return
			this.currentValue = this.currentValue.replace(this.regexp, this.replacement);
		},
		handleMouseEnter() {
			!!this.focusOnHover && this.$refs.input.focus();
			this.hover = true
		},
		handleMouseLeave() {
			this.hover = false
		},
		handleClickClearIcon(e) {
			if (!!this.clearOnClickDeleteIcon && !!this.hoverDeleteIcon && this.hover && !this.lv_disabled && !this.lv_readonly) {
				this.currentValue = null
				this.$emit('input', this.currentValue)
				this.$emit('change', this.currentValue)
			}
			!this.hideClearIcon && this.$emit('click-suffix-icon', e)
		},
		handleClickSuffixIcon(e) {
			this.$emit('click', e)
		},
		handleValidate() {
			if (!this.currentRules) {
				this.isValidate = true
				this.validateMsg = null
				return
			}
			if (!!this.validateTimer) {
				clearTimeout(this.validateTimer)
				this.validateTimer = null;
			}
			this.validateTimer = setTimeout(() => this.validate(), 100)
		},
		async handleClickInput(e) {
			this.$emit('click', e)
			this.lv_openRecommendService()
		},
		async lv_openRecommendService() {
			if (this.lv_readonly || this.lv_disabled) return
			if (!!this.recommendData) {
				if (!this.lv_recommendService) {
					this.lv_showAllRecommendData = true
					this.lv_recommendService = await this.$select.select(this.recommendOption)
				}
			}
		},
		lv_resetRecommendData() {
			if (!!this.recommendData) this.recommendOption.data = this.recommendData
		},
		async lv_keyup(e) {
			this.$emit('up', e)
			!!this.lv_recommendService && this.lv_recommendService.prev()
		},
		async lv_keydown(e) {
			this.$emit('down', e)
			!!this.lv_recommendService && this.lv_recommendService.next()
		},
		async lv_keyleft(e) {
			this.$emit('left', e)
		},
		async lv_keyright(e) {
			this.$emit('right', e)
		},
		async lv_keyenter(e) {
			this.$emit('enter', e)
			if (!!this.recommendData) {
				if (!!this.lv_recommendService) this.lv_recommendService.confirm()
				else this.lv_openRecommendService()
			}
		},
	},
};
</script>

<style lang="scss">
@include themeify {
	.link-input {
		display: inline-flex;
		align-items: center;
		box-sizing: border-box;
		vertical-align: bottom;
		position: relative;
		transition: all 0.15s linear;

		.link-input-wrapper {
			display: inline-block;
			height: 100%;
			flex: 1;
			position: relative;
			box-sizing: border-box;
			padding: 1px;

			input {
				height: 100%;
				width: 100%;
				outline: none;
				border: none;
				display: inline-block;
				padding-left: 8px;
				padding-right: 8px;
				box-sizing: border-box;
				float: left;

				&::-ms-clear {
					display: none;
				}

				&::-webkit-outer-spin-button,
				&::-webkit-inner-spin-button {
					-webkit-appearance: none !important;
					margin: 0;
				}

				&:disabled {
					background-color: initial;
				}

				&:-webkit-autofill {
					background-color: white !important;
				}
			}

			.link-input-clear-icon {
				position: absolute;
				right: 0;
				top: 1px;
				bottom: 1px;
				cursor: pointer;
				background-color: white;
				padding-left: 2px;
				padding-right: 8px;
				box-sizing: border-box;
				height: initial;
				color: $icon-color;
			}
		}

		.link-input-prepend, .link-input-append, .link-input-prefix-icon, .link-input-suffix-icon, .link-input-clear-icon {
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.link-input-prefix-icon {
			padding: 0 8px;
		}

		.link-input-suffix-icon {
			padding-right: 8px;
		}

		.link-input-prefix-icon, .link-input-suffix-icon {
			user-select: none;
			color: $icon-color;

			.link-icon {
				@include transition-all;
				cursor: pointer;
			}
		}

		.link-input-tooltip {
			$tooltip-color: rgba($color-error, 0.7);
			visibility: visible;
			width: max-content;
			color: $tooltip-color;
			text-align: center;
			padding: 3px 6px;
			font-size: 12px;
			/* 定位 */
			position: absolute;
			z-index: 0;
			top: calc(100% + 3px);
			left: 0;
		}

		/*shape*/
		@each $key, $value in $list-shape {
			&.link-input-shape-#{$key} {
				border-radius: $value;
			}
		}
		/*size*/
		@each $key, $value in $list-size {
			&.link-input-size-#{$key} {
				height: $value - 2;

				&, & input {
					font-size: $value/2.5;
					line-height: ceil($value/2.5);
				}

				.link-input-prepend, .link-input-append {
					height: $value;
					line-height: $value;
				}
			}
		}
		/*fill type*/
		&.link-input-fill {
			@include pl-colors(link-input) {
				border: solid $border-size $value;
				@include input-placeholder-color;

				&, & input {
					background: $value;
					color: white;
				}
			}
		}

		/*line type*/
		&.link-input-line {
			@include pl-colors(link-input) {
				border: solid $border-size $value;
				background: white;
				@include input-placeholder-color;

				&, & input {
					color: $color-normal-input;
				}

				input {
					background: transparent;
				}
			}

			&.link-input-dashed {
				border-style: dashed;
			}

			&.link-input-readonly {
				input {
					color: $placeholder-color;
				}
			}
		}

		/*none type*/
		&.link-input-none {
			@include pl-colors(link-input) {
				border: solid $border-size transparent;
				@include input-placeholder-color;

				&, & input {
					background: transparent;
					color: $color-normal-input
				}
			}
		}

		/*long*/
		&.link-input-long {
			width: 100% !important;

			.link-input-wrapper {
				flex: 1;

				input {
					width: 100% !important;
				}
			}
		}

		/*disabled*/
		&.link-input-disabled {
			&, & input {
				background-color: $color-normal-disabled !important;
				color: $color-normal-disabled-text !important;;
				cursor: not-allowed;
			}
		}

		&.link-input-focus {
			&:not(.link-input-disabled):not(.link-input-readonly) {
				outline: pl-var(outline);
			}
		}

		&.link-input-focus, &:hover {
			&:not(.link-input-disabled):not(.link-input-readonly) {
				border-color: pl-var(color-primary) !important;
			}
		}

		&.link-input-has-suffix-icon {
			.link-input-clear-icon {
				padding-right: 2px;
			}
		}

		&.link-input-align-left {
			.link-input-wrapper > input {
				text-align: left;
			}
		}

		&.link-input-align-center {
			.link-input-wrapper > input {
				text-align: center;
			}
		}

		&.link-input-align-right {
			.link-input-wrapper > input {
				text-align: right;
			}
		}
	}

	.link-form-item-invalidate .link-input, .link-input.link-input-invalid {
		&.link-input-focus {
			&:not(.link-input-disabled):not(.link-input-readonly) {
				outline-color: rgba($color-error, 0.1);
			}
		}

		&.link-input-focus, &:hover {
			&:not(.link-input-disabled):not(.link-input-readonly) {
				border-color: $color-error !important;
			}
		}

		&.link-input-line {
			border-color: $color-error;
		}
	}
}
</style>
